module.exports = __webpack_public_path__ + "img/img14.0fc651b5.jpg";